class UserNotePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'user_note.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'user_note._m';

    // Access archived
    static ACCESS_ARCHIVE = 'user_note.access.archive';

    // Can act on resources where not an owner/author
    static ACT_OPT_NO_OWNER = 'user_note.act.opt.no_owner';

    // Can create new user notes
    static CREATE = 'user_note.create';

    // Update note content
    static CONTENT_UPDATE = 'user_note.content.update';

    // Archive note
    static ARCHIVE = 'user_note.archive';

    // Restore archived note
    static RESTORE = 'user_note.restore';
}

export default UserNotePermission;
